import ShopBannerCTA from './ShopBannerCTA';

export default ShopBannerCTA;
